import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import { IResponseAjud } from '../../../../shared/services/types/response';
import moment from 'moment';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import {
  convertIrregularDateFormat,
  maskCPFCNPJ,
  maskMonetaryValue,
  maskOnlyNumbers,
  moneyMask,
} from '../../../../shared/utils/mask';
import { toast } from 'react-toastify';
import { api } from '../../../../shared/services/api';
import { AxiosError, AxiosRequestConfig } from 'axios';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  height: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #cecece',
  borderRadius: 5,
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

interface ModalDetailProps {
  ajudValue: IResponseAjud | null;
  closeModal: (shouldReload?: boolean) => void;
  open: boolean;
}

const ModalDetail = ({ open, ajudValue, closeModal }: ModalDetailProps) => {
  const token = Cookies.get('@token');
  const [updated, setUpdated] = useState(false);
  const [updatingArchive, setUpdatingArchive] = useState(false);
  const [dropdownValue, setDropdownValue] = useState<string | undefined>('01');
  const [avaliableValue, setAvaliableValue] = useState<string>('');

  //const [dropdownAccountSalary, setDropdownAccountSalary] = useState<string>("F");

  // const handleDropdownBlockAccountSalary = (event: any) => {
  //   setDropdownValue(event.target.value);
  // };
  useEffect(() => {
    if (ajudValue?.response_code) {
      setDropdownValue(ajudValue.response_code);
    }

    if (ajudValue?.account_value_available) {
      setAvaliableValue(ajudValue.account_value_available);
    }
  }, [ajudValue]);

  const handleDropdownChange = (event: SelectChangeEvent<string>) => {
    setDropdownValue(event.target.value);
  };

  const handleUpdateArchive = async () => {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-type': 'application/json',
        Accept: 'application/json',
      },
    };

    const body = {
      account_value_available: maskOnlyNumbers(avaliableValue),
      response_code: dropdownValue,
    };

    setUpdatingArchive(true);
    try {
      const responseUpdatedAjud = await api.put(
        `/ajudArchive/ajudUpdate/${ajudValue?.id}`,
        body,
        config,
      );

      if (responseUpdatedAjud.status === 200) {
        toast.success('Arquivo atualizado com sucesso');
      }
    } catch (err: unknown) {
      if (err instanceof AxiosError) {
        const errorMessage = err.response?.data?.message || 'Erro de conexão';
        toast.error(errorMessage);
      } else {
        toast.error('Erro inesperado');
      }
    } finally {
      setUpdatingArchive(false);
      setUpdated(true);
    }
    setUpdated(true);
    setUpdatingArchive(false);
    handleClose(true);
  };

  const resetStates = () => {
    setUpdated(false);
    setDropdownValue('01');
    setAvaliableValue('');
  };

  const handleClose = (shouldReload?: boolean) => {
    resetStates();
    closeModal(shouldReload);
  };

  return (
    <Modal
      open={open}
      onClose={() => handleClose(true)}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box sx={{ ...style }}>
        <Box display="flex" alignItems="center" flexWrap="wrap">
          <Typography
            variant="h6"
            sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' } }}
          >
            Detalhes do AJUD: {ajudValue?.response_code}
          </Typography>
          <Typography
            ml={1}
            color="primary.main"
            variant="h6"
            sx={{ fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' } }}
          >
            {ajudValue?.court_order}
          </Typography>
        </Box>

        <Typography
          variant="body1"
          sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, mt: 2 }}
        >
          Data protocolização:{' '}
          {moment(ajudValue?.date_protocolization.slice(0, 8)).format(
            'DD/MM/yyyy',
          )}
        </Typography>

        <Box
          mt={6}
          component="form"
          sx={{ '& > :not(style)': { m: 1 } }}
          noValidate
          autoComplete="off"
        >
          {ajudValue?.partner_name && (
            <Box display="flex" alignItems="baseline" mb={1}>
              <Typography
                variant="body1"
                fontWeight="bold"
                mr={1}
                sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
              >
                Parceiro:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
              >
                {ajudValue?.partner_name}
              </Typography>
            </Box>
          )}
          {ajudValue?.partner_name && (
            <Box display="flex" alignItems="baseline" mb={1}>
              <Typography
                variant="body1"
                fontWeight="bold"
                mr={1}
                sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
              >
                Tipo:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
              >
                {ajudValue?.type_record}
              </Typography>
            </Box>
          )}
          <Box display="flex" flexWrap="wrap" gap={2}>
            <Box display="flex" alignItems="baseline" mb={1}>
              <Typography
                variant="body1"
                fontWeight="bold"
                mr={1}
                sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
              >
                Ordem judicial:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
              >
                {ajudValue?.court_case}
              </Typography>
            </Box>
            <Box display="flex" alignItems="baseline" mb={1}>
              <Typography
                variant="body1"
                fontWeight="bold"
                mr={1}
                sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
              >
                Data envio:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
              >
                {convertIrregularDateFormat(ajudValue?.shipping_date)}
              </Typography>
            </Box>
            <Box display="flex" alignItems="baseline" mb={1}>
              <Typography
                variant="body1"
                fontWeight="bold"
                mr={1}
                sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
              >
                Documento do bloqueio:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
              >
                {maskCPFCNPJ(ajudValue?.cnpj_cpf_oj)}
              </Typography>
            </Box>
          </Box>

          <Box display="flex" flexWrap="wrap" gap={2}>
            <Box display="flex" alignItems="baseline" mb={1}>
              <Typography
                variant="body1"
                fontWeight="bold"
                mr={1}
                sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
              >
                Valor bloqueado:
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
              >
                {maskMonetaryValue(ajudValue?.lock_value, 'R$')}
              </Typography>
            </Box>
          </Box>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="dropdown-label">Código resposta</InputLabel>
            <Select
              label="Código resposta"
              defaultValue={ajudValue?.response_code}
              labelId="dropdown-label"
              value={dropdownValue}
              onChange={handleDropdownChange}
              disabled={
                updated ||
                ajudValue?.status == 'DONE' ||
                ajudValue?.status == 'PENDING' ||
                ajudValue?.status == 'CREATED'
              }
            >
              <MenuItem value="00">
                Resposta negativa: o réu/executado não é cliente (não possui
                contas) ou possui apenas contas inativas, ou a instituição não é
                responsável sobre o registro de titularidade, administração ou
                custódia dos ativos.
              </MenuItem>
              <MenuItem value="01">01 - Cumprida integralmente</MenuItem>
              <MenuItem value="02">
                02 - Réu/executado sem saldo positivo.
              </MenuItem>
              <MenuItem value="03">
                03 - Cumprida parcialmente por insuficiência de saldo.
              </MenuItem>
              <MenuItem value="05">
                05 - Réu/executado sem saldo disponível devido a bloqueio total
                anterior.
              </MenuItem>
              <MenuItem value="08">
                08 - Réu/executado não é titular da agência/conta indicada
              </MenuItem>
              <MenuItem value="09">
                09 - Número da agência ou conta é inválido.
              </MenuItem>
              <MenuItem value="12">
                12 - Cumprida integralmente, afetando depósito a prazo.
              </MenuItem>
              <MenuItem value="13">
                13 - Cumprida parcialmente por insuficiência de saldo, afetando
                depósito a prazo,títulos ou valores mobiliários.
              </MenuItem>
              <MenuItem value="15">
                15 - Valor reservado: depósito judicial será efetuado caso
                ocorra solicitação de transferência.
              </MenuItem>
              <MenuItem value="16">
                16 - Cumprida integralmente em outras instituições do
                agrupamento.
              </MenuItem>
              <MenuItem value="17">
                17 - Cumprida integralmente, afetando depósito a prazo.
              </MenuItem>
              <MenuItem value="18">
                18 - Cumprida integralmente com bloqueio parcial nesta
                instituição, afetando depósito a prazo.
              </MenuItem>
              <MenuItem value="20">
                20 - Resposta negativa: réu/executado possui apenas ativos
                comprometidos em composição de garantia ou em ciclo de
                liquidação ou resgate.
              </MenuItem>
              <MenuItem value="21">
                21 - Cumprida. Bloqueio efetuado em ativo indivisível.
              </MenuItem>
              <MenuItem value="22">
                22 - Cumprida parcialmente por insuficiência de saldo, afetando
                ativo indivisível.
              </MenuItem>
              <MenuItem value="23">
                23 - Cumprida parcialmente por insuficiência de saldo
                disponível, afetando depósitos à prazo, títulos ou valores
                mobiliários. Além do valor bloqueado, o executado possui ativos
                comprometidos em composição de garantia, ou em ciclo de
                liquidação ou resgate.
              </MenuItem>
              <MenuItem value="24">
                24 - Cumprida parcialmente por insuficiência de saldo, afetando
                ativo indivisível. Além do valor bloqueado, o executado possui
                ativos comprometidos em composição de garantia, ou em ciclo de
                liquidação ou resgate.
              </MenuItem>
              <MenuItem value="25">
                25 - Cumprida totalmente ou parcialmente. Bloqueio efetuado em
                ativo escriturado ou por instituição sem comando para venda.
              </MenuItem>
              <MenuItem value="26">
                26 - Cumprida totalmente ou parcialmente. Bloqueio efetuado em
                ativo de baixa liquidez.
              </MenuItem>
              <MenuItem value="27">
                27 - Cumprida total ou parcialmente. Bloqueio efetuado em ativo
                não precificado.
              </MenuItem>
              <MenuItem value="28">
                28 - Cumprida totalmente ou parcialmente. Bloqueio afetou
                valores mobiliários de titularidade da União, Estado, Distrito
                Federal ou Município, os quais permanecerão bloqueados mas não
                serão liquidados via SISBAJUD, devendo o juízo determinar a
                alienação pelas vias próprias.
              </MenuItem>
            </Select>
          </FormControl>
          {/* <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="dropdown-label">Indicador conta</InputLabel>
            <Select
              labelId="dropdown-label"
              value={dropdownAccountSalary}
              onChange={handleDropdownBlockAccountSalary}
              disabled={true}
            >
              <MenuItem value="F">F - Não houve bloqueio de conta salário</MenuItem>
              <MenuItem value="T">T - Bloqueio conta salário </MenuItem>
            </Select>
          </FormControl> */}
          <FormControl sx={{ flex: 1 }}>
            <InputLabel htmlFor="component-outlined">
              Valor disponível
            </InputLabel>
            <OutlinedInput
              id="component-outlined"
              defaultValue={'teste'}
              label="Valor disponível"
              value={moneyMask(avaliableValue)}
              onChange={(e) => setAvaliableValue(e.target.value)}
              disabled={
                updated ||
                ajudValue?.status == 'DONE' ||
                ajudValue?.status == 'PENDING' ||
                ajudValue?.status == 'CREATED'
              }
            />
          </FormControl>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            position: 'absolute',
            bottom: 16,
            right: 16,
          }}
        >
          {!updated && ajudValue?.status != 'DONE' && (
            <Button
              variant="contained"
              color="primary"
              disabled={
                updatingArchive ||
                ajudValue?.status == 'DONE' ||
                ajudValue?.status == 'PENDING' ||
                ajudValue?.status == 'CREATED'
              }
              onClick={handleUpdateArchive}
              sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
            >
              Atualizar informações
            </Button>
          )}
          <Button
            sx={{ marginLeft: 2, fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
            variant="contained"
            color="error"
            onClick={() => handleClose()}
          >
            Cancelar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalDetail;
